import { useFieldArray } from 'react-hook-form';
import SchoolRecordInput from './SchoolRecordInput';

const AwardsTable = ({ register, control, name, type, isRead }) => {

    const { fields, append, remove } = useFieldArray({
        control,
        name
    });

    const title = type === 'awards' ? 'Title of Awards' : 'Appointment'
    const level = type === 'awards' ? 'Level' : 'Position'

    return (
        <table className='table table-sm table-bordered text-center align-middle'>
            <colgroup>
                <col width={"auto"} />
                <col width={"auto"} />
                <col width={"120px"} />
                <col width={"auto"} />
                {!isRead && <col width={"70px"} />}
            </colgroup>
            <thead>
                <tr>
                    <th className='py-2'>{title}</th>
                    <th className='py-2'>{level}</th>
                    <th className='py-2'>Date</th>
                    <th className='py-2'>Presenter</th>
                    {!isRead && <th className='py-2'></th>}
                </tr>
            </thead>

            <tbody>
                {fields.map((field, index) => {
                    return (
                        <tr key={field.id}>
                            <td>
                                <SchoolRecordInput register={register} name={`${name}.${index}.title`} isRead={isRead} />
                            </td>
                            <td>
                                <SchoolRecordInput register={register} name={`${name}.${index}.level`} isRead={isRead} />
                            </td>
                            <td>
                                <SchoolRecordInput type='date' register={register} name={`${name}.${index}.date`} isRead={isRead} />
                            </td>
                            <td>
                                <SchoolRecordInput register={register} name={`${name}.${index}.presenter`} isRead={isRead} />
                            </td>
                            {!isRead
                                && <td>
                                    <button type="button" className={`btn btn-sm btn-outline-danger`} onClick={() => { remove(index) }}>삭제</button>
                                </td>
                            }
                        </tr>
                    )
                })}

                {!isRead &&
                    <tr>
                        <td colSpan={isRead? 4 : 5}>
                            <button
                                type="button"
                                className={`btn btn-sm btn-outline-primary`}
                                onClick={() => append({ title: '', level: '', date: '', presenter: '' })}
                            >추가</button>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default AwardsTable